import React from 'react';
import { Alert } from 'cstar-react-primitives/lib/redux-form/alert/Alert';
import { Container } from 'cstar-react-primitives/lib/redux-form/layout/Container';

import errorMessages from './errorMessages';


const NotFound = () => (
    <Container hasSlimPadding>
        <Alert
            alertType="warning"
            hasHeading={false}
            message={errorMessages.notFoundTitle}
        />
    </Container>
);

export default NotFound;
